import React from 'react';

const IntlContext = React.createContext({
  locale: 'en',
  messages: {}
});

export default IntlContext;
